angular.module('zc.zenclerkS')
  .controller('ZcsProjectUserController', ZcsProjectUserController);

ZcsProjectUserController.$inject = ['$document', '$rootScope', '$scope', '$stateParams', 'ProjectUser', 'currentUser', 'users'];
function ZcsProjectUserController($document, $rootScope, $scope, $stateParams, ProjectUser, currentUser, users) {
  const vm = this;
  vm.users = users;
  vm.state = {};
  vm.currentUser = currentUser;
  vm.newUser = { email: '', full_name: '' };
  vm.state = {};

  if(vm.users.length === 0) {
    vm.state.addUser = true;
  } else {
    vm.state.addUser = false;
  }

  const itemMargin = 20; // can't get outer height with JS so here the hardcoded margin TODO: use a wrapper
  vm.css = {
    newItemHeight: angular.element($document[0].querySelector('.list-new'))[0].offsetHeight + itemMargin
  };
  vm.css.listItemTranslation = 0;
  vm.toggleNew = toggleNew;
  vm.inviteUser = inviteUser;
  vm.removeUser = removeUser;

  //# Control for duplicate users
  $scope.$watch('vm.newUser.email', function(email) {
    if(email && !!_.find(vm.users, {email})) {
      $scope.form.$invalid = true; // disable form submit
      vm.state.duplicateUser = true; // show warning message
    } else {
      vm.state.duplicateUser = false;
    }
  });

  function sortUsers() {
    vm.users = _.sortBy(vm.users, function(user) {
      if(vm.currentUser.id === user.id) {
        return -1;
      }
      return user.id;
    });
  }

  function toggleNew() {
    // remove to origine
    if(vm.state.addUser) {
      vm.css.listItemTranslation = 0;
    // display add user form
    } else {
      vm.css.listItemTranslation = vm.css.newItemHeight;
    }
    vm.state.addUser = !vm.state.addUser;
  }

  //# Invite user
  function inviteUser() {
    ProjectUser.create($stateParams.apikey, vm.newUser)
      .then(function(user) {
        vm.toggleNew();
        vm.users.push(user);
        sortUsers();
        vm.newUser = { email: '', full_name: '' };
        $rootScope.$emit('projectUpdated', vm.project);
      });
  }

  //# Remove user
  function removeUser(user) {
    ProjectUser.destroy($stateParams.apikey, user.id)
      .then(function(deletedUser) {
        _.remove(vm.users, u => u.id === deletedUser.id);
        sortUsers();
      });
  }

}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/users/project_user.controller.js